import { PERMISSIONS } from './usersPermissions/usersPermissionsCultivares';

export const isDiseases = (roles: string[]): boolean => {
    const isRole = roles.filter(role => role === PERMISSIONS.ReqRegistroAvaliarDoenca);

    return isRole.length ? true : false;
}